import { Tasks, Tasker } from '../utils/types';

export function generateAssignedTaskEmail({
  task,
  taskers,
}: {
  task: Tasks;
  taskers: (Tasker & { rating?: number })[];
}) {
  const TITLE =
    taskers.length > 1
      ? 'Encontramos los Taskers perfectos!!'
      : 'Encontramos el Tasker perfecto!!';

  const generateTaskerCard = (
    tasker: Tasker & { rating?: number },
    index: number
  ) => `
    <table width="100%" cellspacing="0" cellpadding="0" style="background-color: #f3f4f6; border-radius: 10px; margin-bottom: 30px;">
      <tr>
        <td style="padding: 20px;">
          <p style="color: #333333; font-size: 18px; font-weight: bold; margin: 0 0 20px 0;">
            ${
              taskers.length > 1
                ? `Tu Tasker ${index + 1} será `
                : 'Tu Tasker será '
            }${tasker.name}
          </p>

          <!-- Tasker Info Row -->
          <table width="100%" cellspacing="0" cellpadding="0">
            <tr>
              <td style="width: 100%; vertical-align: middle;">
                <table cellspacing="0" cellpadding="0">
                  <tr>
                    <td style="vertical-align: middle;">
                      <img src="${tasker.photo_selfie_url}" alt="${
    tasker.name
  }" width="60" height="60" style="border-radius: 50%; display: block; margin-right: 10px;">
                    </td>
                    <td style="vertical-align: middle;">
                      <p style="color: #333333; font-size: 16px; margin: 0;">${
                        tasker.name
                      } ${tasker.last_name}</p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <!-- University, Career, and Rating -->
          <table width="100%" cellspacing="0" cellpadding="0" style="margin-top: 20px;">
            <tr>
              <td style="padding-bottom: 10px;">
                <p style="color: #666666; font-size: 14px; margin: 0;">Universidad</p>
                <p style="color: #333333; font-size: 16px; margin: 5px 0 0 0;">${
                  tasker.university
                }</p>
              </td>
            </tr>
            <tr>
              <td style="padding-bottom: 10px;">
                <p style="color: #666666; font-size: 14px; margin: 0;">Carrera</p>
                <p style="color: #333333; font-size: 16px; margin: 5px 0 0 0;">${
                  tasker.career || tasker.carreer
                }</p>
              </td>
            </tr>
            ${
              tasker.rating !== undefined
                ? `
            <tr>
              <td>
                <p style="color: #666666; font-size: 14px; margin: 0;">Calificación</p>
                <p style="color: #333333; font-size: 16px; margin: 5px 0 0 0;">
                  <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/star-icon.png" alt="Star" style="vertical-align: middle; width: 16px; height: 16px; margin-right: 4px;">
                  ${tasker.rating}
                </p>
              </td>
            </tr>
            `
                : ''
            }
          </table>
        </td>
      </tr>
    </table>
  `;

  return `
    <table width="100%" cellspacing="0" cellpadding="0" style="background-color: #f3f4f6; font-family: Arial, 'Helvetica Neue', sans-serif;">
      <tr>
        <td align="center" style="padding: 20px 0;">
          <table width="100%" cellspacing="0" cellpadding="0" style="max-width: 600px; border-radius: 10px; overflow: hidden;background-color: white">
            <tr>
              <td>
                <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/email-top-assigned.png" alt="Tasky Header" width="100%" style="display: block; max-width: 100%;">
              </td>
            </tr>
            <tr>
              <td bgcolor="#ffffff" style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">
                <table width="100%" cellspacing="0" cellpadding="0">
                  <tr>
                    <td style="padding: 40px 20px 20px;">
                      <h1 style="text-align: center; color: #333333; margin-top: 0; margin-bottom: 40px;">${TITLE}</h1>

                      <p style="color: #333333; font-size: 18px; margin-bottom: 30px;">Hola ${
                        task.name
                      },</p>
                      <p style="color: #333333; font-size: 18px; margin-bottom: 30px;">Encontramos ${
                        taskers.length > 1
                          ? 'las personas ideales'
                          : 'la persona ideal'
                      } para realizar tu Task:</p>

                      ${taskers
                        .map((tasker, index) =>
                          generateTaskerCard(tasker, index)
                        )
                        .join('')}

                      <p style="color: #333333; font-size: 18px; margin-bottom: 30px;">Se contactará${
                        taskers.length > 1 ? 'n' : ''
                      } ${
    taskers.length > 1 ? 'los Taskers' : 'el Tasker'
  } a la brevedad por Whatsapp🚀</p>

                      <!-- Footer (unchanged) -->
                      <table width="100%" cellspacing="0" cellpadding="0" bgcolor="#8B5CF6" style="margin-top: 40px; padding: 20px; border-radius: 10px;">
                        <tr>
                          <td align="center">
                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/tasky-logo-dark-theme.png" alt="Tasky Logo" width="80" style="display: block; margin: 0 auto;">
                            <div style="margin-top: 20px;">
                              <a href="https://www.instagram.com/tasky.cl" style="margin: 0 10px; outline: none; text-decoration: none;">
                                <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/instagram-icon.png" alt="Instagram" width="24">
                              </a>
                              <a href="https://www.linkedin.com/company/taskyapp/" style="margin: 0 10px; outline: none; text-decoration: none;">
                                <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/linkedin-icon.png" alt="LinkedIn" width="24">
                              </a>
                              <a href="https://www.tiktok.com/@tasky.cl" style="margin: 0 10px; outline: none; text-decoration: none;">
                                <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/tiktok-icon.png" alt="TikTok" width="24">
                              </a>
                            </div>
                            <p style="color: #ffffff; font-size: 11px; margin-top: 10px;">Pide tu Task y universitarios resuelven</p>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `;
}
